<h4>{{title}}</h4>
<div class="container">
  <mat-progress-bar mode="determinate" [value]="value"></mat-progress-bar>
  <span>{{value.toFixed(1)}}%</span>
</div>
